import { toast } from 'sonner';
import { DEMO_COPY_HELD_HEADER, DEMO_COPY_REFUSALS } from '@altsui/shared';

/** A private demo copy answers a send it held back like any other; this says nothing was sent. Returns the response untouched. */
export function noticeHeldSend(response: Response): Response {
  if (response.headers.get(DEMO_COPY_HELD_HEADER)) {
    toast(DEMO_COPY_REFUSALS.demo_copy_no_send.message, { id: 'demo_copy_no_send' });
  }
  return response;
}
